'use client';
import { createContext } from 'react';

/** HOW the Settings primitives in `./SettingsSurface` draw, decided by the surface they render in rather
 *  than by each call site, so one section component (a core panel, or a plugin's through
 *  `window.ElowenUiRuntime`) reads right in both places without knowing where it was mounted.
 *
 *  `page` is the Settings look: every group a raised section card. It is the default, so Settings,
 *  Account and every window built on `SettingsPage` never provide anything.
 *
 *  `drawer` is the compact detail-drawer look, provided by `WorkspaceDetailRail sectioned` (the Project
 *  and User drawers) around its body: a group is a section, its title outside one rounded, hairline-
 *  bordered box whose records are hairline-divided lines with the labels in one fixed column; lists are
 *  rows of that same box, and a state is a quiet line in it. The primitives mark what they drew with
 *  `data-settings-presentation="drawer"`.
 *
 *  `Modal` provides `page` again around every dialog's content, so a window opened FROM a drawer (a pull
 *  request's detail, a confirmation) keeps the look it has everywhere else.
 *
 *  Its own module because `Modal` reads it, and `SettingsSurface` reaches `Modal` through `WorkspaceShell`. */
export const SettingsPresentationContext = createContext<'page' | 'drawer'>('page');
